module.exports = __webpack_public_path__ + "assets/img/tab3_07.b1dcc03c.jpg";